<template>
  <div id="investments-page">
    <!-- <PageTitle title="Let's Farm For You" /> -->
    <b-container class="pb-5">
      <b-row class="mb-4">
        <!-- <b-col cols="12">
          <div
            class="d-flex bg-light dash-card"
            style="height:auto; overflow: hidden;"
          >
            <div class="text-left m-3 mb-1">
              <b-row>
                <b-col>You are just a few steps to completion.<br />Buy or Rent a farm, then pay for any of the farming services below.</b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col>
                    <router-link
                          to="/farms/ownership"
                          id="farm_for_u_btn"
                          class="btn btn-dark dash-btn"
                        >
                          Buy a Farm
                    </router-link>

                    <router-link
                          to="/farms/rentals"
                          id="farm_for_u_btn"
                          style="margin-left:10px"
                          class="btn btn-primary dash-btn"
                        >
                          Rent a Farm
                    </router-link>

                </b-col>
              </b-row>
            </div>
          </div>
        </b-col> -->
      </b-row>
      <b-row align-v="stretch">
        <!-- <b-col cols="12" md="4" class="mb-4">
          <router-link to="farms/funding">
            <button class="btn w-100 dash-card text-left bg-white p-3 action-btn">

              <img src="@/assets/images/fund_farm.jpg" />
              
            </button>
          </router-link>
        </b-col> -->
        <!-- <b-col cols="12" md="4" class="mb-4">
          <router-link to="farms/ownership">
            <button
              class="btn w-100 dash-card text-left bg-white p-3 action-btn"
            >
              <img src="@/assets/images/own_farm.jpg" />
              <div class="text-center bg-dark text-light p-3 mm-text">
                You can buy a very fertile farmland and we will help you
                cultivate it, while you make the Money.<br /><b
                  >You Own, We Farm, You Earn.</b
                >
              </div>
            </button>
          </router-link>
        </b-col>
        <b-col cols="12" md="4" class="mb-4">
          <router-link to="farms/rentals">
            <button
              class="btn w-100 dash-card text-left bg-white p-3 action-btn"
            >
              <img src="@/assets/images/rent_farm.jpg" />
              <div class="text-center bg-dark text-light p-3 mm-text">
                For all Agriculture enthusiasts, You lease a fertile farm land
                and we can help you cultivate while you earn.
              </div>
            </button>
          </router-link>
        </b-col> -->
      </b-row>

      <b-row class="mt-4" v-if="loadingData && !loadError">
        <b-col
          cols="12"
          md="6"
          lg="6"
          xl="4"
          v-for="item in 3"
          :key="item"
          class="mb-4"
        >
          <b-progress
            variant="primary"
            :max="100"
            class="w-100"
            show-progress
            animated
            height="200px"
          >
            <b-progress-bar :value="100">Loading...</b-progress-bar>
          </b-progress>
        </b-col>
      </b-row>
      <b-row v-else-if="loadError" class="mt-4" align-v="stretch">
        <b-col cols="12" class="mb-4">
          <div class="text-center" title="Could not load, click on retry">
            <b-button
              class="w-100"
              style="height:200px"
              size="sm"
              @click="loadPackages()"
              variant="light"
            >
              <bad-network-icon />
              <br />Error Loading Data, <br />click to retry
              <reload-icon class="ml-1" />
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-else align-v="stretch">
        <b-col
          class="mb-5"
          cols="12"
          md="6"
          lg="6"
          xl="4"
          v-for="item in packages"
          :key="item.id"
          :order="item.slug == 'co-ownership' ? '1' : '2'"
          style="margin-top:50px"
        >
          <div class="wrap dash-card bg-white position-relative">
            <div class="wrap px-4 position-absolute w-100">
              <div
                class="dash-card thumb bg-dark shadow-xl bg-cover"
                style="height:150px;margin-top:-50px"
                :style="{
                  backgroundImage:
                    ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url(` +
                    item.imageurl +
                    `)`,
                }"
              ></div>
            </div>
            <div class="wrap bg-light px-5 pt-2 text-white">
              <b-row align-h="between">
                <b-col cols="auto">
                  <component :is="`co-ownership-icon`" :size="50"></component>
                  <h6 class="mb-0">Farm for Me</h6>
                  <!-- <span v-if="item.slug == 'co-ownership'" style="font-size:15px;">Earn rent for life</span>
                <span v-else style="font-size:15px;">Share in real estate money</span>-->
                </b-col>
              </b-row>
            </div>
            <!-- <hr /> -->
            <div class="wrap p-4 mt-2">
              <b-row>
                <b-col>
                  <h5 class="mb-0 mr-2">{{ item.farmingname }}</h5>
                  <span
                    >Earn <strong>{{ item.minroi + "% - " +item.maxroi + "%" }}</strong></span
                  >
                  <span> in {{ item.farmingcycle }} months</span>
                </b-col> 
              </b-row>
              <!-- <hr /> -->
              <b-row class="mt-1">
                <b-col>
                  <h5 class="text-primary">
                    {{ formatMoney(item.amountperplot) }}
                    <span
                      class="font-weight-normal ml-1 text-dark"
                      style="font-size:16px"
                      >per unit</span
                    >
                  </h5>
                  <b-button
                    variant="primary"
                    class="w-100 btn-sm"
                    @click="handleInvest(item)"
                    >Subscribe
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <!--<hr class="mt-0" />
            <div class="wrap px-4 pb-4">
              <b-row no-gutters>
                <b-col cols="6">
                  <router-link
                    to="farms/ownership"
                    class="w-100 btn btn-primary btn-sm"
                    >Buy a Farm</router-link
                  >
                </b-col>
                <b-col cols="6">
                  <router-link
                    to="farms/rentals"
                    variant="light"
                    class="w-100 btn btn-light btn-sm"
                    >Rent a Farm</router-link
                  >
                </b-col>
              </b-row>
            </div>-->
          </div>
        </b-col>
      </b-row>
    </b-container>

    <InvestModal />
  </div>
</template>

<script>
import PageTitle from "@/components/ui/PageTitle";
import { TransactionService } from "@/services";
import { formatMoney } from "@/utils/helpers";
import loadData from "@/mixins/loadData";
import InvestDrawer from "./investDrawer";

export default {
  components: {
    PageTitle,
  },

  data() {
    return {
      packages: {},
    };
  },
  mixins: [loadData],

  methods: {
    formatMoney,
    async loadPackages() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const {
          data: packageList,
        } = await TransactionService.getFarmServices();

        // Convert for Options
        // const packages = {};
        // const packagesROI = {};

        //add placeholder to force users to select a package
        // packages[0] = "Select a Package";
        // packagesROI[0] = 0;

        // packageList.forEach(ele => {
        //   packages[ele.id] = `${ele.packagename} - ${
        //     ele.duration
        //   } months - ${formatPercent(ele.roi / 100)}`;
        //   packagesROI[ele.id] = Number(ele.roi) / 100;
        // });
        this.packages = packageList;
        // this.packagesROI = packagesROI;
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },

    handleInvest(subscription) {
      const panelResult = this.$showPanel({
        component: InvestDrawer,
        openOn: "right",
        width: "495px",
        disableBgClick: true,
        props: {
          subscription: subscription,
        },
      });

      panelResult.promise.then((result) => {
        if (result.closedBy != "bg") {
          this.$emit("setActiveTab");
        }

        //result is the value passed from your component calling this.$emit('close-panel', //some value);
      });
    },
    getBG(slug) {
      if (slug == "crowd-funding") {
        return "https://www.aljazeera.com/mritems/imagecache/mbdxxlarge/mritems/images/2020/4/7/87ff1f4a00234175b5561cf577cbccf8_18.jpg";
      } else {
        return "https://www.aljazeera.com/mritems/imagecache/mbdxxlarge/mritems/images/2020/4/7/87ff1f4a00234175b5561cf577cbccf8_18.jpg";
      }
    },
  },

  mounted() {
    this.loadPackages();
  },
};
</script>

<style lang="scss" scoped>
.mm-text {
  font-size: 14px;
  border-radius: 0px 0px 10px 10px;
}

h5 {
  color: #555;
  margin-top: 10px;
}

.dash-card {
  height: auto;
  padding: 1px !important;
}

.dash-card img {
  width: 100%;
  border-radius: 5px;
}
.action-btn {
  -webkit-box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
}

.action-btn:hover {
  -webkit-box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.1),
    0 5px 5px -5px rgba(0, 0, 0, 0.04);
  box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.1),
    0 5px 5px -5px rgba(0, 0, 0, 0.04);
  -webkit-transition: all 0.3s ease;
  transition: all 0.1s ease;
  border-radius: 10px;
}
</style>
